
<script>
import { VERSION } from '../../../config/prod.env.js'

export default {
  name: 'footer',
  data() {
    return {
      version: _.trim(VERSION, '"')
    }
  },
  computed: {
    thisYear() {
      const dt = new Date()
      return dt.getFullYear()
    }
  }
}
</script>

<template>
  <footer class="footer">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-md-3">
          <img src="/static/images/HeltOpplagtLogo.png" />
        </div>

        <div class="col-xs-12 col-md-3">
          <ul>
            <router-link tag="li" :to="{ name: 'contractlist' }" exact>
              <a>Nettmeny</a>
            </router-link>
            <router-link tag="li" :to="{ name: 'catering' }" exact>
              <a>Catering</a>
            </router-link>
          </ul>
        </div>

        <div class="col-xs-12 col-md-3">
          <ul>
            <li>
              <a href="#">
                <strong>Support 0800 - 1600</strong>
              </a>
            </li>
            <li>
              <i class="fa fa-phone" aria-hidden="true"></i>
              <a href="tel:02346">0 23 46</a>
            </li>
            <li>
              <a href="mailto:post@heltopplagt.no">post@heltopplagt.no</a>
            </li>
          </ul>
        </div>

        <!-- <div class="col-md-3">
          <ul>
            <li>
              <a href="#"><strong>Tjenester</strong></a>
            </li>
            <li>
              <a href="#">Lunsjkurver</a>
            </li>
          </ul>
        </div>-->
      </div>
      <div>
        <div class="row">
          <div class="col-md-6">
            <a href="https://www.facebook.com/Heltopplagt" target="_blank">
              <i class="fa fa-2x fa-facebook-official" aria-hidden="true"></i>
            </a>
            <a href="https://plus.google.com/+HeltopplagtNofruktlunsjogrenluft/" target="_blank">
              <i class="fa fa-2x fa-google-plus-square" aria-hidden="true"></i>
            </a>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            {{ thisYear }} &#169; Helt Opplagt på Jobben.
            <a href="#">Bruker- og salgsbetingelser.</a>
            <span class="app__version pull-right">v{{ this.version }}</span>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<style lang="stylus" scoped>
.footer {
  margin-top: 200px;
}

ul {
  list-style: none;
  padding: 0;
}

.app__version {
  font-size: 10px;
}
</style>



// WEBPACK FOOTER //
// footer.vue?50495a00